import {useIntl} from 'react-intl';

export const TABLE_SCROLL_HEIGHT = 320;
export const COMPUTED_PAGE_SIZE = 50;

/** Mensaje de tabla vacía: distingue "no hay nada" de "el filtro no encontró". */
export function emptyMessageId(filtersActive) {
    return filtersActive
        ? 'RELEVANCE.PROMOTED_FILTERED_EMPTY'
        : 'RELEVANCE.PROMOTED_TABLE_EMPTY';
}

/** "Sí" / "No" traducido para una bandera booleana. */
export function YesNo({value}) {
    const intl = useIntl();
    return intl.formatMessage({
        id: value
            ? 'RELEVANCE.PROMOTED_AUTO_RANKING_ON'
            : 'RELEVANCE.PROMOTED_AUTO_RANKING_OFF',
    });
}
